import React from 'react';
import './AddPaymentPorterWizard.css';

const UDF_FIELDS = Array.from({ length: 40 }, (_, i) => `UDFC${String(i + 1).padStart(2, '0')}`);

const DEFAULT_SUBTITLE = "OHIP user-defined character field where this configuration records its marker so the same reservation isn't processed twice.";

const WizardMarkerStep = ({ udfField, onChange, subtitle = DEFAULT_SUBTITLE, onBack, onNext }) => (
    <div className="ppw-card">
        <div className="ppw-card-header">
            <h2 className="ppw-card-title">Processed Marker (UDF)</h2>
            <p className="ppw-card-subtitle">{subtitle}</p>
        </div>
        <div className="ppw-card-body">
            <div className="ppw-field">
                <label className="ppw-label">UDF field</label>
                <select
                    className="ppw-input"
                    value={udfField}
                    onChange={e => onChange(e.target.value)}
                    style={{ maxWidth: 220 }}
                >
                    {UDF_FIELDS.map(name => (
                        <option key={name} value={name}>{name}</option>
                    ))}
                </select>
            </div>
        </div>
        <div className="ppw-footer">
            <button className="ppw-btn-back" onClick={onBack}>← Back</button>
            <button className="ppw-btn-next" onClick={onNext}>Next →</button>
        </div>
    </div>
);

export default WizardMarkerStep;
